// extracted by mini-css-extract-plugin
export default {"grecaptcha-badge":"MainPage_grecaptcha-badge__Bx3bB","mainPage":"MainPage_mainPage__wQBk4"};